import React, { Fragment } from 'react';

import appSettings from 'wanderu-config';

// The no-JS fallback fires from every environment, so it has to follow the
// configured collector rather than a fixed host: otherwise dev and pilot page
// loads without JS land in prod data.
function noJsPixelUrl() {
    const { endpoint, customPath } = appSettings.config.snowplow;
    return `https://${endpoint}${customPath.get}?e=se&aid=ui_react&tna=pixel&se_ca=sp_load&se_ac=failed&se_pr=no_js`;
}

function Snippet() {
    return (
        <Fragment>
            <script dangerouslySetInnerHTML={{
                __html: `
            (function fireHandshakePixel() {
                function generateUUID() {
                    var d = new Date().getTime();
                    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
                        d += performance.now(); //use high-precision timer if available
                    }
                    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                    });
                }

                window.__uuid = generateUUID();
                var queryString = 'e=se';
                queryString += '&se_ca=' + 'pixel_page_load';
                queryString += '&se_ac=' + 'loaded';
                queryString += '&se_pr=' + window.__uuid;
                queryString += '&url=' + encodeURIComponent(window.location.href);
                queryString += '&refr=' + encodeURIComponent(window.top.document.referrer);
                queryString += '&aid=' + 'ui_react';
                queryString += '&tna=' + 'pixel';

                var url = 'https://' + window.appSettings.config.snowplow.endpoint + '/i?' + queryString;

                var pixel = document.createElement('img');
                pixel.setAttribute('src', url);
                pixel.setAttribute('style', 'display: none; visibility: hidden;');
                document.querySelector('body').appendChild(pixel);
            })()`,
            }} />
            <noscript>
                <img alt="" height="1" src={noJsPixelUrl()} style={{ display: 'none' }}
                    width="1"
                />
            </noscript>
        </Fragment>
    );
}

export default Snippet;
